export const RMH_ADDRESS = {
  address1: "7940 Jones Branch Drive",
  city: "Tysons",
  state: "VA",
  zipCode: "22102",
  zipPlusFourCode: "3381",
};

export const RMH_TAX_ID = "93-4524823";
export const RMH_NPI = "1134981244";
export const RMH_ORGANIZATION_NAME = "RightMove Physical Therapy Services PLLC";

export const SUPPORT_EMAIL = "help@rightmovehealth.clinic";

/**
 * Email domain every staff account (Provider, Admin) lives on. The domain is
 * what tells staff and patients apart at sign-in, before any Cognito lookup has
 * happened. The one patient exception is a Staff Test Account: a plus-addressed
 * address on this domain (`name+test@...`), which signs in as a patient.
 *
 * Note `preSignUpOidcUser` in the backend keys off the looser `.clinic` TLD
 * rather than this exact domain. Callers here match the full domain, which is
 * the safe direction to differ in: it routes fewer people at SSO, never more.
 */
export const STAFF_EMAIL_DOMAIN = "rightmovehealth.clinic";
export const SUPPORT_PHONE = "(888) 514-7220";
export const SUPPORT_PHONE_TEL_HREF = `tel:${SUPPORT_PHONE.replace(/\D/g, "")}`;

export const RMH_PHONE_NUMBER = "(888) 514-7220";
export const RMH_FAX_NUMBER = "(866) 280-0319";

export const RMH_AMAZON_INSURANCE_PLAN_LINK =
  "https://www.rightmovehealth.com/amazon";

export const RMH_PROVIDER = {
  organizationName: RMH_ORGANIZATION_NAME,
  npi: RMH_NPI,
};
